import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getInventory } from '../Api'

export default generateApiAction({
  baseType: Types.INVENTORIES.GET,
  api: getInventory,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/inventories/GetAction.js